import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import backDripp from '../../assets/backdrip-hearts.png';

function SingleMessagesView({currentEvent}) {
    
    const visibleMessages = currentEvent.eventMessages.filter((msg) => msg.visible);

    const [index, setIndex] = useState(0);

    // Manual navigation
  const prevSlide = () => {
    setIndex((prev) =>
      prev === 0 ? visibleMessages.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setIndex((prev) =>
      prev === visibleMessages.length - 1 ? 0 : prev + 1
    );
  };

  // Auto slide every 7 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) =>
        prev === visibleMessages.length - 1 ? 0 : prev + 1
      );
    }, 7000); // 7000ms = 7 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [visibleMessages.length]);

  const current = visibleMessages[index];
  return (
     <div className="section-full-height creamyback message-slider"
            style={{
                backgroundImage: `url(${backDripp})`
            }}
        >
       <div className="container text-center">
           <div className="testamonial">
                <div className="block-testimonial-content">{current.message}</div>
                <div className="block-testimonial-title">— {current.name} — </div>
                <div className="index-indicator">
                    {index + 1} of {visibleMessages.length}
                </div>
                <div className="slider-buttons">
                    <button className="btn btn-main " onClick={prevSlide}>Prev</button>
                    <button className="btn btn-main" onClick={nextSlide}>Next</button>
                </div>
           </div>
       </div>
    </div>
  )
}

export default SingleMessagesView